(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbDocumentView', DocumentViewDirective)
		.controller('smbDocumentViewController', [
			'$scope',
			'pxProgressService',
			'smbPanelDetailsDataStore',
			'smbToolbarService',
			'smbDocumentDataStore',
			'smbContentUploadDataStore',
			'smbDocumentViewerNavigationService',
			DocumentViewController
		]);

	var templateUrl = require('./documentView.template');
	function DocumentViewDirective() {
		return {
			restrict: 'E',
			controller: 'smbDocumentViewController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				documentGroupId: '@',
				documentTypeId: '@',
				documentId: '@'
			},
			scope: {}
		};
	}

	function DocumentViewController($scope, pxProgressService, smbPanelDetailsDataStore, smbToolbarService, smbDocumentDataStore, smbContentUploadDataStore, smbDocumentViewerNavigationService) {
		var vm = this;
		pxProgressService.visible = true; 
		vm.docPages = [];
		vm.panelDetailsDS = smbPanelDetailsDataStore;

		(function initDocumentViewController() {
			smbToolbarService.backArrowState = smbDocumentViewerNavigationService.backState;
			if (smbDocumentViewerNavigationService.backStateParams) {
				smbToolbarService.backArrowStateParams = smbDocumentViewerNavigationService.backStateParams;
			}

			loadDoc();

			var unsubscribe = smbContentUploadDataStore.onUploadSuccess(function() {
				loadDoc();
			});

			$scope.$on('$destroy', function() {
				unsubscribe();
			});
		}());

		function loadDoc() {
			return smbDocumentDataStore.loadDocument(vm.documentId)
				.then(function () {
					vm.docPages = smbDocumentDataStore.pageUrls;
				})
				.finally(function(){					
					pxProgressService.visible = false; 
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/documentView/documentView.js
// module id = 86
// module chunks = 1